import { axios } from '@Root/API'

export const remove = (studyProgrammeId, courseRoleId) => {
	return axios.delete(`program/${studyProgrammeId}/course-role/${courseRoleId}`)
}
